export class RegisterBackNavModel {
    disableChecbox: boolean;
}